import { UNIT_TYPE, USER_STATUS } from 'constants/constants';

export const formatConstantData = (constant) => {
  const label = constant.replaceAll('_', ' ');
  return `${label[0].toUpperCase()}${label.slice(1).toLowerCase()}`;
};
export const formatConstToSelectOptions = (constant) => {
  const result = Object.values(constant).map((item) => {
    const label = item.replaceAll('_', ' ');
    return {
      value: item,
      label: `${label[0].toUpperCase()}${label.slice(1).toLowerCase()}`,
    };
  });
  result.unshift({ value: '', label: 'All Event', select: true });
  return result;
};

export const formatDataApiToSelectOption = (data, type) => {
  switch (type) {
    case 'users': {
      const result = data.map((item) => ({
        value: item?._id,
        label: item?.fullName,
      }));
      result.unshift({ value: '', select: true, label: 'All users' });
      return result;
    }
    case 'courses': {
      const result = data.map((item) => ({
        value: item?._id,
        label: item?.name,
      }));
      result.unshift({ value: '', select: true, label: 'All courses' });
      return result;
    }
    case 'intakes': {
      const result = data.map((item) => ({
        value: item?._id,
        label: item?.name,
      }));
      result.unshift({ value: '', select: true, label: 'All intakes' });
      return result;
    }
    default:
      return null;
  }
};

export const convertToTitleCase = (value) => {
  if (value === UNIT_TYPE.SUB_SECTION) {
    value = 'sub section';
  } else if (value === USER_STATUS.INACTIVE) {
    value = 'De-Active';
  }
  return value
    ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    : '';
};
export const convertToCapitalize = (value) => {
  return value
    ? value
        .split('_')
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(' ')
    : '';
};

export function convertToUserNameStg(name) {
  if (!name) return '';

  const cleaned = String(name).trim().replace(/\s+/g, ' ');
  if (!cleaned) return '';

  const parts = cleaned.split(' ').filter(Boolean);

  const firstChar = (str) => [...str][0] || '';

  let initials = '';

  if (parts.length >= 2) {
    initials = firstChar(parts[0]) + firstChar(parts[1]);
  } else {
    const chars = [...parts[0]];
    initials = chars.slice(0, 2).join('');
  }

  return initials.toUpperCase();
}

export function stringToColor(str) {
  if (!str) return '#cccccc'; // fallback color

  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  // convert hash to hex color
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += ('00' + value.toString(16)).slice(-2);
  }
  return color;
}
